import { Domain } from 'library/ts/model/enums/web/Domain';
import { getSmartTagRuntimeVO } from 'tag/ts/smart_tag/utilities/Runtime';
import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
export class AbstractFWSiteParams extends AbstractFreewheelClass {
    excludedFMSKeys = [
        '_fw_app_bundle',
        '_fw_atts',
        '_fw_did',
        '_fw_is_lat',
        '_fw_nielsen_app_id',
        'fms_idfv',
        'fms_ifa',
        'imafw__fw_app_bundle',
        'imafw__fw_atts',
        'imafw__fw_did',
        'imafw__fw_is_lat'
    ];
    constructor(argument) {
        super({
            name: 'AbstractFWSiteParams',
            ...argument
        });
    }
    get adParameters() {
        return this.adParams;
    }
    createLinearParams() {
        const paramsVO = this?.tag?.params;
        const fmsResponse = paramsVO?.AD?.FW?.FMS;
        const fmsValues = {};
        for (const k in fmsResponse) {
            if (k.indexOf('fms_') > -1) {
                fmsValues[k] = fmsResponse[k];
            }
        }
        const params = {
            _fw_nielsen_app_id: 'P0C0C37AD-20C4-4EF7-AF25-BEBCB16DF85E',
            _fw_hylda: 'acid=tpplushylda&aiid=[AIID]&abid=break://[AIID]/[ABID]',
            _fw_vcid2: fmsResponse?._fw_vcid2,
            _fw_player_height: '1080',
            _fw_player_width: '1920',
            _fw_coppa: '0',
            _fw_us_privacy: paramsVO?.USER?.usPrivacy,
            ...fmsValues
        };
        this?.logger?.log('createLinearParams:', params);
        return params;
    }
    createIMAParams() {
        const paramsVO = this?.tag?.params;
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        const metadata = this?.tag?.model?.apiMetadata;
        const utils = window.SmartTag.utilities;
        const fmsResponse = paramsVO?.AD?.FW?.FMS;
        const gdprResponse = paramsVO?.AD?.FW?.GDPR;
        const runtimeVO = getSmartTagRuntimeVO();
        const isPPlus = !!runtimeVO.top.parsed.host.includes(Domain.PPLUS);
        const coppa = (!!isPPlus && !utils.Type.isEmpty(siteSessionData?.tfcd)) ? siteSessionData.tfcd.toString() : undefined;
        const isLive = !!this?.tag?.model?.contentUtilities?.isLive(paramsVO, metadata);
        const params = {
            _fw_ae: paramsVO?.USER?.mvpdId,
            _fw_continuous_play: !!isLive ? undefined : siteSessionData?.cpSession,
            _fw_coppa: coppa,
            _fw_vcid2: fmsResponse?._fw_vcid2,
            _fw_gdpr: gdprResponse?._fw_gdpr?.toString(),
            _fw_gdpr_consent: gdprResponse?._fw_gdpr_consent?.toString(),
            region: siteSessionData?.region
        };
        this?.logger?.log('createIMAParams:', params);
        return params;
    }
    createDAISDKParams() {
        const paramsVO = this?.tag?.params;
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        const metadata = this?.tag?.model?.apiMetadata;
        const utils = window.SmartTag.utilities;
        const fmsResponse = paramsVO?.AD?.FW?.FMS;
        const gdprResponse = paramsVO?.AD?.FW?.GDPR;
        const runtimeVO = getSmartTagRuntimeVO();
        const isPPlus = !!runtimeVO.top.parsed.host.includes(Domain.PPLUS);
        const coppa = (!!isPPlus && !utils.Type.isEmpty(siteSessionData?.tfcd)) ? siteSessionData.tfcd.toString() : undefined;
        const isLive = !!this?.tag?.model?.contentUtilities?.isLive(paramsVO, metadata);
        const isIntl = this.tag.tagUtilities.isInternationalContext(this?.tag);
        const params = {
            imafw__fw_ae: paramsVO?.USER?.mvpdId,
            imafw__fw_vcid2: fmsResponse?._fw_vcid2,
            imafw__fw_us_privacy: paramsVO?.USER?.usPrivacy,
            imafw__fw_gdpr: gdprResponse?._fw_gdpr?.toString(),
            imafw__fw_gdpr_consent: gdprResponse?._fw_gdpr_consent?.toString(),
            imafw_region: siteSessionData?.region
        };
        if (!isLive) {
            params.imafw__fw_continuous_play = siteSessionData?.cpSession;
            params.imafw__fw_coppa = coppa;
        }
        if (isIntl) {
            params.imafw__fw_is_lat = siteSessionData?._fw_is_lat;
        }
        this?.logger?.log('createDAISDKParams:', params);
        return params;
    }
    createDAISSBParams() {
        const paramsVO = this?.tag?.params;
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        const utils = window.SmartTag.utilities;
        const fmsResponse = paramsVO?.AD?.FW?.FMS;
        const gdprResponse = paramsVO?.AD?.FW?.GDPR;
        const runtimeVO = getSmartTagRuntimeVO();
        const isPPlus = !!runtimeVO.top.parsed.host.includes(Domain.PPLUS);
        const coppa = (!!isPPlus && !utils.Type.isEmpty(siteSessionData?.tfcd)) ? siteSessionData.tfcd.toString() : undefined;
        const isIntl = this.tag.tagUtilities.isInternationalContext(this?.tag);
        const params = {
            imafw__fw_ae: paramsVO?.USER?.mvpdId,
            imafw__fw_coppa: coppa,
            imafw__fw_vcid2: fmsResponse?._fw_vcid2,
            imafw__fw_us_privacy: paramsVO?.USER?.usPrivacy,
            imafw__fw_gdpr: gdprResponse?._fw_gdpr?.toString(),
            imafw__fw_gdpr_consent: gdprResponse?._fw_gdpr_consent?.toString()
        };
        if (isIntl) {
            params.imafw__fw_is_lat = siteSessionData?._fw_is_lat;
        }
        this?.logger?.log('createDAISSBParams:', params);
        return params;
    }
    createDAIAPIParams() {
        const paramsVO = this?.tag?.params;
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        const metadata = this?.tag?.model?.apiMetadata;
        const isLive = !!this?.tag?.model?.contentUtilities?.isLive(paramsVO, metadata);
        const params = {
            imafw__fw_app_bundle: 'unknown',
            imafw__fw_continuous_play: !!isLive ? undefined : siteSessionData?.cpSession,
            imafw__fw_coppa: siteSessionData?.tfcd?.toString(),
            imafw__fw_did: 'unknown:54bc9b53-79ac-4946-98ba-2f989e315418',
            imafw__fw_h_referer: 'unknown',
            imafw__fw_is_lat: '0',
            imafw__fw_vcid2: 'b539d5e0d43130d617d64f8991f0a3e0',
            imafw__fw_us_privacy: paramsVO?.USER?.usPrivacy
        };
        this?.logger?.log('createDAIAPIParams:', params);
        return params;
    }
    appendFMSData(fwSiteParams) {
        const fmsResponse = this.tag?.params?.AD?.FW?.FMS;
        if (this.utils?.Type?.isNullOrUndefined(fmsResponse)) {
            this.logger?.log('appendFMSData:', 'missing fmsResponse... returning FW site params', '\nparamsVO.AD.FW:', this.tag?.params?.AD?.FW);
            return fwSiteParams;
        }
        const prefix = 'imafw_';
        Object.keys(fmsResponse)
            .filter((key) => !this.excludedFMSKeys.includes(key) && !fwSiteParams[key])
            .forEach((key) => {
            if (this.excludedFMSKeys.includes(key)) {
                this?.logger?.log('appendFMSData:', 'key:', key, 'is excluded from being passed from FMS to FW params');
                return;
            }
            if (!this.utils.Type.isEmpty(fwSiteParams[key])) {
                this?.logger?.log('appendFMSData:', 'key:', key, 'is already set in FW site params, will not override');
                return;
            }
            const paramsKey = (key.substring(0, prefix.length) !== prefix) ? prefix + key : key;
            fwSiteParams[paramsKey] = fmsResponse[key];
        });
        this.logger?.log('appendFMSData:', '\nFMS response:', fmsResponse, '\nparams:', fwSiteParams);
        return fwSiteParams;
    }
}
